import React, { forwardRef, useEffect, useState } from 'react'
import { CustomModal } from '@components'
import { Box, FormControl, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, Typography, FormHelperText } from '@mui/material'
import { apiSellIntraday, apiGetOrder } from '@store';
import { useDispatch } from 'react-redux';
import { showToast } from '@utils';

const Sell = forwardRef(({ handleClose, selectedContract, user }, ref) => {
    const dispatch = useDispatch();

    const [state, setState] = useState({
        market: 'NCG',
        type: 'sell',
        price_selected: '',
        seller: user?.CompanyShort,
        buyer: '',
        volume: '',
        ordertype: 'internal',
        sym: selectedContract
    })
    const [submitting, setSubmitting] = useState(false)
    const [showVolumeError, setShowVolumeError] = useState(false)
    const [type, setType] = useState('bid')

    useEffect(() => {
        if (user?.CanSellTo?.length > 0) {
            setState((prevState) => ({
                ...prevState,
                buyer: user.CanSellTo[0]
            }))
        }
    }, [user])

    const handleChange = (e) => {
        const { name, value } = e.target
        setState({
            ...state,
            [name]: value
        })
        if (name === 'volume') {
            const vol = parseFloat(value)
            setShowVolumeError(value !== '' && !(vol > 0))
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (submitting) return;
        setSubmitting(true);

        const volume = parseFloat(state.volume)
        if (!(volume > 0)) {
            setShowVolumeError(true)
            showToast('error', 'Volume must be greater than 0')
            setSubmitting(false)
            return
        }

        const data = {
            ...state,
            volume,
        }

        const resp = await dispatch(apiSellIntraday(data))
        if (resp?.meta?.requestStatus === 'fulfilled') {
            showToast('success', 'Sales Order Saved')
            handleClose()
            dispatch(apiGetOrder())
            setSubmitting(false)
        } else if (resp?.meta?.requestStatus === 'rejected') {
            showToast('error', resp?.payload)
            setSubmitting(false)
        }
    }

    // timer
    const [timer, setTimer] = useState(60);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer(timer => timer - 1);
        }, 1000);
        return () => clearInterval(interval);
    }, [timer]);

    useEffect(() => {
        if (timer === 0) {
            handleClose();
        }
    }, [timer, handleClose]);

    useEffect(() => {
        if (ref?.current) {
            setTimer(60);
        }
    }, [ref]);

    return (
        <CustomModal
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            timer={timer}
            modalTitle={`Sell Contract`}
            modalTitleColor={'#EB6969'}
            buttonText={'Sell'}
            className='modal-button-danger'
            disabled={submitting || !state.volume}  // updated: disable if submitting or volume not entered
            ref={ref}
        >
            <Box className='flex flex-col gap-3'>
                <FormControl fullWidth>
                    <InputLabel
                        id="demo-simple-select-label"
                        sx={{ bgcolor: '#F5F5F5', pr: 1 }}
                    >
                        Please Select what you would like to sell
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Type"
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                    >
                        <MenuItem value="bid">Bid Price</MenuItem>
                    </Select>
                </FormControl>
                <Box className='flex gap-3'>
                    <Typography>Contract:</Typography>
                    <Typography color={'black'}>{selectedContract?.Contract}</Typography>
                </Box>
                <Box className='flex gap-3'>
                    <Typography>Max Volume User Can Sell:</Typography>
                    <Typography color={'black'}>{selectedContract?.Quantity}</Typography>
                </Box>
                <Box className='flex gap-3'>
                    <Typography>Price:</Typography>
                    <Typography color={'black'}>{selectedContract?.Price}</Typography>
                </Box>
                {/* <Box className='flex gap-3'>
                    <Typography>Settlement Price:</Typography>
                    <Typography color={'black'}>{selectedContract?.Price * state?.volume || 0}</Typography>
                </Box> */}
                <FormControl fullWidth variant="outlined" error={showVolumeError}>
                    <InputLabel
                        id="contractLabel"
                        sx={{ bgcolor: '#F5F5F5', p: '0 3px' }}
                    >
                        Volume
                    </InputLabel>
                    <OutlinedInput
                        id="volume"
                        label="Volume"
                        name="volume"
                        onChange={handleChange}
                        value={state.volume}
                        type="number"
                        inputProps={{ step: 0.01, min: 0 }}
                        required
                        endAdornment={
                            <InputAdornment position="start">
                                MW
                            </InputAdornment>
                        }
                    />
                    <FormHelperText>
                        {showVolumeError ? 'Volume must be greater than 0' : ''}
                    </FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                    <InputLabel
                        id="demo-simple-select-label"
                        sx={{ bgcolor: '#F5F5F5', pr: 1 }}
                    >
                        Sell To
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Sell To"
                        name='buyer'
                        value={state.buyer}
                        onChange={handleChange}
                    >
                        {user?.CanSellTo?.map((seller, index) => (
                            <MenuItem key={index} value={seller}>{seller}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <Box className='flex gap-3'>
                    <Typography>Last Updated:</Typography>
                    <Typography color={'black'}>{ }</Typography>
                </Box>
            </Box>
        </CustomModal>
    )
})

export default Sell